import { RouteWithGates } from '../api/routes';
import { Gate } from '../types/Gate';
import { RouteClusterGroup } from './routeClustering';

/**
 * Pinned gates are a team-wide shortlist of commonly used gate pairs
 * (`gates.pinned`). These helpers float them to the top of a list without
 * otherwise disturbing its order — every sort here is stable, so whatever
 * order the list arrived in (latitude sweep, address) still holds within the
 * pinned and unpinned halves.
 */

export function routeHasPinnedGate(route: RouteWithGates): boolean {
  return route.gates?.some((g) => g.pinned) ?? false;
}

export function sortGatesPinnedFirst(gates: Gate[]): Gate[] {
  return [...gates].sort((a, b) => Number(b.pinned) - Number(a.pinned));
}

/** Routes holding a pinned gate first, and those routes' gates pinned-first. */
export function sortRoutesPinnedFirst(routes: RouteWithGates[]): RouteWithGates[] {
  return routes
    .map((r) => (r.gates ? { ...r, gates: sortGatesPinnedFirst(r.gates) } : r))
    .sort((a, b) => Number(routeHasPinnedGate(b)) - Number(routeHasPinnedGate(a)));
}

/** Clusters holding a pinned gate first; within each, routes as above. */
export function sortClustersPinnedFirst(clusters: RouteClusterGroup[]): RouteClusterGroup[] {
  return clusters
    .map((c) => ({ ...c, routes: sortRoutesPinnedFirst(c.routes) }))
    .sort((a, b) => (
      Number(b.routes.some(routeHasPinnedGate)) - Number(a.routes.some(routeHasPinnedGate))
    ));
}
